import { suggestedAddressesResults } from './data';
import { ADDRESS_POSTCODE_SUGGESTION_QUERY } from '@zoopla/listing-search-queries';

export const fetchAddressPostcodeSuggestionsResults = {
    request: {
        query: ADDRESS_POSTCODE_SUGGESTION_QUERY,
        variables: {
            addressPartial: 'biller'
        }
    },
    result: {
        ...suggestedAddressesResults
    }
};
